/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AdminTalentPoolCreateRequestIcon = typeof AdminTalentPoolCreateRequestIcon[keyof typeof AdminTalentPoolCreateRequestIcon] | null;


export const AdminTalentPoolCreateRequestIcon = {
  users: 'users',
  briefcase: 'briefcase',
  building: 'building',
  globe: 'globe',
  star: 'star',
  heart: 'heart',
  stethoscope: 'stethoscope',
  graduation: 'graduation',
  code: 'code',
  rocket: 'rocket',
  shield: 'shield',
  flask: 'flask',
  leaf: 'leaf',
  sparkles: 'sparkles',
  handshake: 'handshake',
  folder: 'folder',
} as const;
